module.exports = __webpack_public_path__ + "static/media/film.bd7f67c0.jpg";